import "./TopNavbar.css";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaGlobe,
} from "react-icons/fa";

function TopNavbar() {
  return (
    <div className="top-navbar">
      <div className="top-left">

        <span>InteriorMart</span>

        <a href="#">
          <FaFacebookF />
        </a>

        <a href="#">
          <FaInstagram />
        </a>

        <a href="#">
          <FaTwitter />
        </a>

        <a href="#">
          <FaLinkedinIn />
        </a>

      </div>

      <div className="top-right">

        <a href="#">Login</a>

        <a href="#">Register</a>

        <a href="#">
          <FaGlobe />
          English
        </a>

      </div>
    </div>
  );
}

export default TopNavbar;